import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

const DEFAULT_RATE = 1500;

export function useExchangeRate() {
  const [rate, setRate] = useState<number>(DEFAULT_RATE);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRate = async () => {
      try {
        const { data, error } = await supabase
          .from('app_settings')
          .select('value')
          .eq('key', 'usd_to_iqd_rate')
          .single();

        if (error) throw error;
        
        const rateValue = typeof data.value === 'number' 
          ? data.value 
          : parseInt(String(data.value)) || DEFAULT_RATE;
        
        setRate(rateValue);
      } catch (error) {
        console.error('Error fetching exchange rate:', error);
        setRate(DEFAULT_RATE);
      } finally {
        setLoading(false);
      }
    };

    fetchRate();
  }, []);

  const convertUSDToIQD = (usd: number): number => {
    return Math.round(usd * rate);
  };

  const convertIQDToUSD = (iqd: number): number => {
    return Math.round(iqd / rate);
  };

  return { rate, loading, convertUSDToIQD, convertIQDToUSD };
}
